import { reactive } from 'vue'

export type ToastTone = 'info' | 'success' | 'warning' | 'danger'
export interface Toast { id: number; text: string; tone: ToastTone }

export const toasts = reactive<Toast[]>([])
let next = 1

/** Shows a message for 4 s (8 s for an error, which takes longer to read and act on). */
export function toast(text: string, tone: ToastTone = 'info'): void {
  const id = next++
  toasts.push({ id, text, tone })
  setTimeout(() => dismiss(id), tone === 'danger' ? 8000 : 4000)
}

export function dismiss(id: number): void {
  const i = toasts.findIndex((t) => t.id === id)
  if (i >= 0) toasts.splice(i, 1)
}
